module.exports = __webpack_public_path__ + "media/assets/img/screenshots/races-timeline-8e7d2e988abdd84dacb00b53f4dd0b85.png";